<template>
  <div class="dynamic">
    <img class="dynamic-img" src="https://cdn.51ljb.cn/ljb_icons_dynamic_fwdt.png" alt="">
    <div class="line"/>
    <div class="right">
      <van-swipe
        :autoplay="3000"
        :height="30"
        :show-indicators="false"
        :loop="true"
        vertical>
        <van-swipe-item
          v-for="(item,index) in list"
          :key="index">
          <p class="ljb-md-text dynamic-item">{{ item }}</p>
        </van-swipe-item>

        <!--<van-swipe-item>-->
        <!--<li class="dynamic-item ljb-md-text">【快速咨询】 ****刚刚完成了一次快速咨询</li>-->
        <!--</van-swipe-item>-->
        <!--<van-swipe-item>-->
        <!--<li class="dynamic-item ljb-md-text">【快速咨询】 ****刚刚完成了一次快速咨询</li>-->
        <!--</van-swipe-item>-->
        <!--<van-swipe-item>-->
        <!--<li class="dynamic-item ljb-md-text">【快速咨询】 ****刚刚完成了一次快速咨询</li>-->
        <!--</van-swipe-item>-->
      </van-swipe>
    </div>

  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import Vue from 'vue'
Vue.use(Swipe).use(SwipeItem)
export default {
  name: 'DynamicList',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList: function () {
      this.$get.orderDynamic().then((res) => {
        this.list = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .dynamic {
    /*border-radius: 14px;*/
    margin: 0px $padding 0 $padding;
    padding-left:  10px ;
    height: 45px;
    overflow: hidden;
    font-weight: 600;
    font-size: 12px;
    line-height: 45px;
    color:$base-color;
    border-radius: 3px;
    @extend .ljb-double-center;
    @extend .ljb-flex-row;
    // box-shadow:    0px -5px 5px 0px rgba(0, 0, 0, 0.01),   /*上边阴影  红色*/
    // -5px 0px 5px 0px rgba(0, 0, 0, 0.01),   /*左边阴影  绿色*/
    // 5px 0px 5px 0px rgba(0, 0, 0, 0.01),    /*右边阴影  蓝色*/
    // 0px 5px 5px 0px rgba(0, 0, 0, 0.01);
  }
  .dynamic-img{
    width: 56px;
    height: 14px;
  }
  .line{
    width: 4px;
    height: 4px;
    background-color: #333333;
    margin-left: 10px;
    border-radius: 2px;
    display: inline;
  }
  .right{
    flex: 1;
    /*display: flex;*/
    /*flex-direction: column;*/
    align-items: center;
  }
  .dynamic-item {
    padding: 9px 11px;
    color: $title-color;
    flex: 1;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/DynamicList.vue